import * as api from "../api";

export const ConfigurationService = {
  getTaxDetails,
  updateTaxDetails,
  getBlackoutTime,
  updateBlackoutTime,
  getOptOutMessage,
  updateOptOutMessage,
};

async function getOptOutMessage() {
  try {
    const { data } = await api.getOptOutMessage();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateOptOutMessage(formData) {
  try {
    const { data } = await api.updateOptOutMessage(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getTaxDetails() {
  try {
    const { data } = await api.getTaxDetails();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateTaxDetails(formData) {
  try {
    const { data } = await api.updateTaxDetails(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getBlackoutTime() {
  try {
    const { data } = await api.getBlackoutTime();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateBlackoutTime(formData) {
  try {
    const { data } = await api.updateBlackoutTime(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
